module.exports = __webpack_public_path__ + "img/guide6.5f9e5f07.jpg";